import { takeLatest, putResolve, select } from 'redux-saga/effects';
import find from 'lodash/find';
import size from 'lodash/size';
import { updateCarpetPrice, updateRoomPrice, updateSelectedChoice } from '../actions';
import { updateStepPrice } from '../actions/stepsAction';
import { pricingNodeSelector } from '../selectors/pricing';
import { roomMeasureSelector } from '../selectors/roomMeasure';
import { configuratorChoices } from '../selectors/configurator';
import { stairs } from '../selectors/stairs';
import { currentItemSelector } from '../selectors/design/currentItem';
import safeSaga from './safeSaga';

const mapReduce = (acc, val) => acc + val;

function* preloadConfiguratorSummaryPrice() {
  try {
    const { choicesWithPrices } = yield select(pricingNodeSelector);
    const choicesFromConfigurator = yield select(configuratorChoices);
    const { itemProduct: { choices } } = yield select(currentItemSelector);
    // 'Select Carpet' is fallback, 'Color/Finish' is SuperSku
    const isCarpetChoice = (optionName) => optionName === 'Select Carpet' || optionName === 'Color/Finish';
    const selectedCarpetChoice = find(choices, (ch) => isCarpetChoice(ch.optionName));

    const selectedCarpetSwatch =
      find(choicesFromConfigurator, (ch) => ch.id === selectedCarpetChoice.choiceId && ch.isSelected === true);
    if (selectedCarpetSwatch) {
      yield putResolve(updateSelectedChoice({ id: selectedCarpetChoice.choiceId }));
    }
    const selectedCarpet = choicesWithPrices.find((choice) => choice.isSelected);
    if (selectedCarpet) {
      // update rooms and steps price
      yield putResolve(updateRoomPrice(selectedCarpet.priceSquareYard));
      yield putResolve(updateStepPrice(selectedCarpet.priceSquareYard));
      const { measure } = yield select(roomMeasureSelector);
      const roomTotals = size(measure) > 0
        ? measure
          .map(({ squarePrice }) => parseFloat(squarePrice))
          .reduce(mapReduce)
        : 0;
      const { stairsSquarePrice } = yield select(stairs) || 0;
      yield putResolve(updateCarpetPrice((roomTotals + stairsSquarePrice).toFixed(2)));
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(`Preload pricing failed: ${err.message}`);
  }
}

export function* persistPriceSaga() {
  yield takeLatest('SAVE_PRICING', safeSaga(preloadConfiguratorSummaryPrice));
}
